import { render, staticRenderFns } from "./MemberDelete.vue?vue&type=template&id=3bd7473b&scoped=true&"
import script from "./MemberDelete.vue?vue&type=script&lang=js&"
export * from "./MemberDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd7473b",
  null
  
)

export default component.exports